import {
  DescriptionsMap,
  readStoredDescriptions,
} from '@/helpers/stockDescriptions'

export interface initialStateInterface {
  byId: DescriptionsMap
}

export const initialState: initialStateInterface = {
  byId: readStoredDescriptions(),
}
